var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("监管单位")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("监管单位列表"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm2 } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "所属省", prop: "val1" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      width: "150px",
                                    },
                                    attrs: { placeholder: "请选择" },
                                    on: { change: _vm.newcityChange },
                                    model: {
                                      value: _vm.ruleForm2.val1,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm2, "val1", $$v)
                                      },
                                      expression: "ruleForm2.val1",
                                    },
                                  },
                                  _vm._l(_vm.newCity, function (item, index) {
                                    return _c("el-option", {
                                      key: item.areaCode,
                                      attrs: {
                                        label: item.name,
                                        value: item.areaCode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-left": "20px" },
                                attrs: { label: "所属市", prop: "val2" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      width: "150px",
                                    },
                                    attrs: { placeholder: "请选择" },
                                    on: { change: _vm.newcityChange1 },
                                    model: {
                                      value: _vm.ruleForm2.val2,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm2, "val2", $$v)
                                      },
                                      expression: "ruleForm2.val2",
                                    },
                                  },
                                  _vm._l(_vm.newCity1, function (item, index) {
                                    return _c("el-option", {
                                      key: item.areaCode,
                                      attrs: {
                                        label: item.name,
                                        value: item.areaCode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-right": "20px" },
                                attrs: { label: "所属区", prop: "val3" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      width: "150px",
                                    },
                                    attrs: { placeholder: "请选择" },
                                    on: { change: _vm.newcityChange2 },
                                    model: {
                                      value: _vm.ruleForm2.val3,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm2, "val3", $$v)
                                      },
                                      expression: "ruleForm2.val3",
                                    },
                                  },
                                  _vm._l(_vm.newCity2, function (item, index) {
                                    return _c("el-option", {
                                      key: item.areaCode,
                                      attrs: {
                                        label: item.name,
                                        value: item.areaCode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-right": "30px" },
                                attrs: { label: "所属街道", prop: "val4" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      width: "150px",
                                    },
                                    attrs: { placeholder: "请选择" },
                                    on: { change: _vm.getorgList1 },
                                    model: {
                                      value: _vm.ruleForm2.val4,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm2, "val4", $$v)
                                      },
                                      expression: "ruleForm2.val4",
                                    },
                                  },
                                  _vm._l(_vm.newCity3, function (item, index) {
                                    return _c("el-option", {
                                      key: item.areaCode,
                                      attrs: {
                                        label: item.name,
                                        value: item.areaCode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-right": "30px" },
                                attrs: { label: "监管单位", prop: "val5" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      width: "150px",
                                    },
                                    attrs: { placeholder: "请选择" },
                                    model: {
                                      value: _vm.ruleForm2.val5,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm2, "val5", $$v)
                                      },
                                      expression: "ruleForm2.val5",
                                    },
                                  },
                                  _vm._l(_vm.orgList1, function (item, index) {
                                    return _c("el-option", {
                                      key: item.name,
                                      attrs: {
                                        label: item.name,
                                        value: item.name,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getorgList("new")
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-table",
              {
                ref: "scrollTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.orgList },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "编号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "province", label: "所属省", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "city", label: "所属市", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "area", label: "所属区", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "streetName",
                    label: "所属街道",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "name", label: "监管单位", align: "center" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }